import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Box, CircularProgress, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';

import { useVenueListNotificationsQuery } from '../../hooks/reactQuery/notifications/useVenueListNotificationsQuery';
import useVenueId from '../../hooks/useVenueId';
import NotificationItem from './NotificationItem';

const DROPDOWN_LIMIT = 8;

type Props = {
  onClose: () => void;
};

const NotificationsDropdown: React.FC<Props> = ({ onClose }) => {
  const venueID = useVenueId();
  const { data, isLoading } = useVenueListNotificationsQuery(venueID);

  const items = React.useMemo(() => data.slice(0, DROPDOWN_LIMIT), [data]);

  return (
    <Box sx={{ width: 380, maxHeight: 540, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}>
        <Typography variant='subtitle1' fontWeight={700}>
          Notifications
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
            <CircularProgress size={24} />
          </Box>
        ) : items.length === 0 ? (
          <Stack alignItems='center' spacing={1} sx={{ py: 5, px: 3, color: 'rgba(0, 0, 0, 0.45)' }}>
            <NotificationsNoneIcon sx={{ fontSize: 40 }} />
            <Typography variant='body2'>You have no notifications yet.</Typography>
          </Stack>
        ) : (
          items.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              compact
              onNavigate={onClose}
            />
          ))
        )}
      </Box>

      <Divider />
      <Box sx={{ px: 2, py: 1.25, textAlign: 'center' }}>
        <MuiLink
          component={RouterLink}
          to='/notifications'
          onClick={onClose}
          underline='hover'
          sx={{ fontWeight: 600, fontSize: '0.875rem', color: '#765BC6' }}
        >
          See all notifications
        </MuiLink>
      </Box>
    </Box>
  );
};

export default NotificationsDropdown;
